import { Grid } from '@mui/material';
import { AuditDateTimeRangeFields } from '../../../../components/AuditDateTimeRangeFields';
import { CustomIdField } from '../../../../components/CustomIdField';
import { ScheduleMetadataFilterFields } from '../../ScheduleMetadataFilterFields';

/**
 * Filter form for spot schedules listing.
 */
export function SchedulesListSpotForm() {
  return (
    <div>
      <AuditDateTimeRangeFields />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <CustomIdField />
        </Grid>
        <ScheduleMetadataFilterFields />
      </Grid>
    </div>
  );
}
